import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useStore from "../store/useStore";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import BlogDetailContent from "../components/BlogDetailContent";

export default function BlogDetail() {
  const { slug } = useParams();
  const { novedades, fetchNovedades } = useStore();

  useEffect(() => {
    fetchNovedades();
  }, [fetchNovedades]);

  // Buscar el blog por slug
  const blog = (novedades || []).find((item) => item.slug === slug);

  if (!blog) {
    return (
      <>
        <Navbar />
        <div className="container py-24 text-center bg-sidom-light dark:bg-sidom-blue">
          <div className="flex flex-col items-center justify-center w-full h-screen">
            <h1 className="text-2xl font-bold">Cargando o no encontrado...</h1>
          </div>
        </div>
        <Footer />
        <Switcher />
      </>
    );
  }

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main>
        <BlogDetailContent blog={blog} />
      </main>
      <footer>
        <Footer />
      </footer>

      <Switcher />
    </>
  );
}
